export function slugifyCategory(category: string) {
  const normalized = category.trim().toLowerCase()
  if (normalized === "award") return "aword"
  if (normalized === "aword") return "aword"
  if (normalized === "competetion") return "competition"
  return normalized
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
}

export function getGalleryHref(category: string) {
  return `/gallery/${slugifyCategory(category)}`
}

// Set when a gallery is opened from the homepage, so the gallery's "Home"
// button can go back in history (restoring the exact scroll position) instead
// of loading the homepage fresh at the top.
const GALLERY_RETURN_KEY = "gallery-return-from-home"

export function markGalleryOpenedFromHome() {
  try {
    sessionStorage.setItem(GALLERY_RETURN_KEY, "1")
  } catch {
    // Storage unavailable (private mode) — the Home link falls back to its href.
  }
}

export function consumeGalleryOpenedFromHome() {
  try {
    const openedFromHome = sessionStorage.getItem(GALLERY_RETURN_KEY) === "1"
    sessionStorage.removeItem(GALLERY_RETURN_KEY)
    return openedFromHome
  } catch {
    return false
  }
}
